import { render, staticRenderFns } from "./ConfigurarLandingModalEdicion.vue?vue&type=template&id=75d6961a&scoped=true&"
import script from "./ConfigurarLandingModalEdicion.vue?vue&type=script&lang=ts&"
export * from "./ConfigurarLandingModalEdicion.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurarLandingModalEdicion.vue?vue&type=style&index=0&id=75d6961a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d6961a",
  null
  
)

export default component.exports